import { debug } from 'console';
import { getText } from './pages';
import { flow1 } from './pages/survey/data';

export const submitAssessment = (data: any, score: any) => {
  if (!data) {
    const str = sessionStorage.getItem('result');
    if (str) {
      data = JSON.parse(str);
    } else {
      return;
    }
  }

  if (score) {
    let flow: any = flow1;
    const questions = flow1;
    flow = flow.filter((x: any) => x.options).map((x: any) => x.options);
    const obj = {} as any;

    obj.Assessment = 'Supplychain';
    let q3Sum = (score.q3 as number[]).reduce((a, b) => a + b, 0);

    let total = score.q2 + q3Sum + score.q4.length + score.q5.length + score.q7;
    let summary = 1;
    if (total > 20) summary = 4;
    else if (total > 15) summary = 3;
    else if (total > 10) summary = 2;
    obj.Result = getText(summary);
    console.log(score);
    let q1Result = flow[0].find((x: any) => x.value === score.q1).text;

    if (q1Result == 'Other') q1Result = sessionStorage.getItem('otherq1');

    obj['q1. ' + questions[0].headerText] = q1Result;
    obj['q2. ' + questions[1].headerText] = flow[1].find(
      (x: any) => x.value === score.q2,
    ).text;
    obj['q3. ' + questions[2].headerText] = score.q3
      .map((y: any) => {
        let text = flow[2].find((x: any) => x.value === y)?.text;
        if (text === 'Other') {
          text += ': ' + sessionStorage.getItem('otherq3');
        }
        return text;
      })
      .filter((x: any) => x);

    obj['q4. ' + questions[3].headerText] = score.q4
      .map((y: any) => {
        let text = flow[3].find((x: any) => x.value === y)?.text;
        if (text === 'Other') {
          text += ': ' + sessionStorage.getItem('otherq4');
        }
        return text;
      })
      .filter((x: any) => x);
    obj['q5. ' + questions[4].headerText] = score.q5
      .map((y: any) => {
        return flow[4].find((x: any) => x.value === y)?.text;
      })
      .filter((x: any) => x);
    obj['q6. ' + questions[5].headerText] = score.q6;

    obj['q7. ' + questions[6].headerText] = flow[5].find(
      (x: any) => x.value === score.q7,
    ).text;

    data['Rental_AMER_19__c'] = JSON.stringify(obj);
  }

  const formid = 54749;
  const munchkinId = '808-GJW-314';
  var utm_campaign_param = sessionStorage.getItem('utm_campaign');
  var utm_source_param = sessionStorage.getItem('utm_source');
  var utm_medium_param = sessionStorage.getItem('utm_medium');
  var utm_content_param = sessionStorage.getItem('utm_content');

  const extra = {
    Utm_Campaign__c: utm_campaign_param,
    Utm_Source__c: utm_source_param,
    Utm_Content__c: utm_content_param,
    Utm_Medium__c: utm_medium_param,
    formVid: formid,
    LeadSource: 'Content Marketing',
    Lead_Source_Description__c:
      'Content Marketing: FY21-Q3-northam-NA1349-website-dl-manu_supply_chain-assessment',
    Product_Family__c: 'Google Cloud Platform',
    Primary_Product_Of_Interest__c: 'Google Cloud Platform',
    PCN_Code__c: '',
    Temp_Field_30day_5__c: '-',
    formid: formid,
    munchkinId: munchkinId,
  };

  const result = { ...data, ...extra };
  sessionStorage.setItem('result', JSON.stringify(result));

  const formData = new FormData();
  for (const key in result) {
    formData.append(key, result[key]);
  }

  return fetch('https://app-sj33.marketo.com/index.php/leadCapture/save2?', {
    method: 'POST',
    body: formData,
    mode: 'no-cors',
  });
};
